<template>
   <v-dialog
      v-model="isActive"
      max-width="640"
      scrollable
      persistent
      @click:outside="clearErrorsAndClose"
      scrim="black"
      opacity="0.8"
   >
      <v-card data-test="error-modal-card">
         <v-card-title dialog-header>
            <span title-medium>Something went wrong</span>
         </v-card-title>
         <v-card-text>
            <p>{{ error ?? '' }}</p>
            <v-list v-if="multilineErrors && multilineErrors.length > 0">
               <v-list-item v-for="(err, index) in multilineErrors" :key="`error-${index}`">
                  <v-list-item-title>{{ err }}</v-list-item-title>
               </v-list-item>
            </v-list>
         </v-card-text>
         <v-card-actions dialog-footer>
            <v-spacer></v-spacer>
            <v-btn variant="flat" size="large" color="primary" @click="clearErrorsAndClose">
               Close
            </v-btn>
         </v-card-actions>
      </v-card>
   </v-dialog>
</template>

<script lang="ts">
import type {PropType} from 'vue';
import {defineComponent} from 'vue';

export default defineComponent({
   props: {
      show: {type: Boolean, required: true},
      errorMessage: {
         type: String as PropType<string | null>,
         required: false,
         default: null,
      },
      multilineErrors: {
         type: Array as PropType<string[]>,
         default: () => [],
      },
   },
   emits: {
      'update:show': (_value: boolean) => true,
      'update:error-message': (_value: string) => true,
      'update:multiline-errors': (_value: string[]) => true,
   },
   data() {
      return {
         isActive: this.show,
         error: this.errorMessage,
         errors: this.multilineErrors,
      };
   },
   watch: {
      show(newVal) {
         this.isActive = newVal;
      },
      errorMessage(newVal) {
         this.error = newVal;
      },
      multilineErrors(newVal) {
         this.errors = newVal;
      },
   },
   methods: {
      clearErrorsAndClose() {
         this.$emit('update:show', false);
         this.$emit('update:error-message', '');
         this.$emit('update:multiline-errors', []);
         this.error = '';
         this.errors = [];
      },
   },
});
</script>

<style lang="scss" scoped></style>
